module.exports = __webpack_public_path__ + "img/xwzxk4.8e36d0fc.png";